$(function () {
    if ($('.upload-dropzone').length > 0) {
            var choose = $('.upload-dropzone')[0];
            var secondChoose = $('.uploaded-photos-list .add-more')[0];

            var uploadChangeHandler = function (evt, files) {
                $('.uploaded-photos-errors').html('');
                if (!files) {
                    var files = FileAPI.getFiles(evt); // Retrieve file list
                }
                $uploadProgress = $('#upload-progress');

                FileAPI.filterFiles(files, function (file, info/**Object*/){
                    if( /^image/.test(file.type) ) {
                        if (info.width < 1920 || info.height < 1080) {
                            $message = $('<p>', {
                                'class': 'alert alert-danger',
                                'html': 'Файл "' + file.name + '" не загружен по причине плохого размера, загрузите другой файл.'
                            });
                            $('.uploaded-photos-errors').append($message);
                        } else {
                            return true;
                        }
                        return false;
                    }
                    return  false;
                }, function (files/**Array*/, rejected/**Array*/){
                    if( files.length ) {
                        if ($uploadProgress.hasClass('hidden')) {
                            $uploadProgress.removeClass('hidden');
                            $uploadProgress.find('.progress-bar').css('width', 0);
                        }

                        // Uploading Files
                        FileAPI.upload({
                            url: '/photo/upload',
                            files: { images: files },
                            progress: function (evt) {
                                var pr = evt.loaded/evt.total * 100;
                                $uploadProgress.find('.progress-bar').css('width', pr+'%');

                            },
                            filecomplete: function (err/**String*/, xhr/**Object*/, file/**Object/, options/**Object*/){
                                if( !err ){
                                    var response = $.parseJSON(xhr.responseText);
                                    if ($('.uploaded-photos-list').hasClass('hidden')) {
                                        $('.uploaded-photos-list').removeClass('hidden');
                                    }

                                    // Make preview 100x100
                                    FileAPI.Image(file).preview(100).get(function (err, img) {
                                        $removeButton = $('<span>', {
                                            'class': 'remove',
                                            'data-target': response.id
                                        });
                                        $removeButton.html('<i class="fa fa-times"></i>');
                                        var $container = $('<div>', {
                                            'class': 'photo'
                                        });
                                        var $img = $(img);
                                        $container.append($img).append($removeButton);
                                        $('.uploaded-photos-list').prepend($container);

                                        $removeButton.on('click', function () {
                                            $(this).parents('.photo').remove();
                                            var id = $(this).data('target');
                                            $.ajax({
                                                url: '/photo/delete',
                                                data: {
                                                    id: id
                                                }
                                            });

                                            $('.hidden-uploaded-photo-list[value='+id+']').remove();
                                        });
                                    });

                                    $input = $('.hidden-uploaded-photo-list:first').clone();
                                    $input.val(response.id).insertAfter($('.hidden-uploaded-photo-list:first'));
                                }
                            },
                            complete: function (err, xhr) {
                                $('.upload-dropzone').parents('form')[0].reset();
                                setTimeout(function () {
                                    $uploadProgress.addClass('hidden');
                                }, 300);
                            }
                        });
                    }
                });
            }

            // $('.uploaded-photos-list .add-more').on('click', function () {
            //     $('.upload-dropzone').find('input:file').trigger('click');
            // });

            FileAPI.event.on(choose, 'change', uploadChangeHandler);
            FileAPI.event.on(secondChoose, 'change', uploadChangeHandler);
            FileAPI.event.dnd(choose, function (over){
                    choose.style.backgroundColor = over ? 'rgba(0,0,0,.1)': '';
                },
                function (files) {
                    uploadChangeHandler(null, files);
                }
            );


            $('#upload-photo-form').on('submit', function (e) {
                e.preventDefault();
                $form = $(this);
                var testForm = $form.find('.hidden-uploaded-photo-list').length;

                if (testForm == 1) {
                    var $message = $('<p>', {
                        'class': 'alert alert-danger',
                        'html': 'Не загружено ни одной фотографии!'
                    });
                    $('.uploaded-photos-errors').html('');
                    $('.uploaded-photos-errors').append($message);
                    return;
                }

                $.ajax({
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    method: 'post',
                    success: function () {
                        $('#upload-success-modal').modal({
                            keyboard: false,
                            show: true,
                            backdrop: 'static'
                        });
                        // $('#upload-success-modal').modal('show');
                    }
                });

                return false;
            });
        }
});
